module.exports = __webpack_public_path__ + "img/wave.12887f8e.png";